import { ActionTree } from 'vuex';

export default <ActionTree<attendance.state.AttendanceState, RootState>>{
};
